import { render } from "./CatDimensionForm.vue?vue&type=template&id=b6341a28&scoped=true"
import script from "./CatDimensionForm.vue?vue&type=script&lang=js"
export * from "./CatDimensionForm.vue?vue&type=script&lang=js"

import "./CatDimensionForm.vue?vue&type=style&index=0&id=b6341a28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6341a28"]])

export default __exports__